import Image, { ImageProps } from 'next/image';
import { ReactNode, useState } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export const FillImage = ({
  src,
  alt,
  errorImage,
  ...props
}: ImageProps & {
  errorImage?: ReactNode;
}) => {
  const [isError, setIsError] = useState(false);
  if (isError || !src)
    return (
      errorImage ?? (
        <div className={cn(props.className, 'relative')}>
          <div className="absolute inset-2">
            <Image
              {...props}
              src="/assets/images/common/wwe-champions-logo-main.webp"
              alt="error"
              sizes="200px"
              fill
            />
          </div>
        </div>
      )
    );
  return (
    <Image
      {...props}
      src={src}
      alt={alt ?? ''}
      fill
      onError={() => setIsError(true)}
    />
  );
};
